import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { EcomProd, Product } from '../classes/product';
import { ProductService } from './product.service';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Resolver {

  public product: EcomProd = {};


  constructor(
    private router: Router,
    public productService: ProductService
  ) { }

  //2.0 Resolver
  resolve(route: ActivatedRouteSnapshot): Observable<EcomProd> {
    // console.log('Called Get Product in resolver...', route);
    // console.log(route.params.id, route.params.cartId)
    return this.productService.ecomproddetails(route.params.id, route.params.cartid).pipe(map(items => {
      // console.log(route.params.id, route.params.cartId)
      // console.log(items)
      return items
      // return items.find((item: any) => {
      //   console.log(item,item.pname.replace(/\s+/g, '-') === route.params.slug)
      //   return item.pname.replace(/\s+/g, '-') === route.params.slug;
      // });
    }));
  }

  //New Resolver
  // resolve(route: ActivatedRouteSnapshot): Observable<EcomProd> {
  //   console.log('Called Get Product in resolver...', route);
  //   return this.productService.ecomproducts().pipe(map(items => {
  //     console.log(items)
  //     return items.find((item: any) => {
  //       console.log(item, item.pname.replace(/\s+/g, '-') === route.params.slug)
  //       return item.pname.replace(/\s+/g, '-') === route.params.slug;
  //     });
  //   }));
  // }

  // OLD Resolver
  // async resolve(route: ActivatedRouteSnapshot): Promise<any> {
  //   return this.productService.getEComProductBySlug(route.params.slug).subscribe(product => {
  //     console.log(product)
  //     if (!product) { // When product is empty redirect 404
  //       this.router.navigateByUrl('/pages/404', { skipLocationChange: false });
  //     } else {
  //       this.product = product
  //     }
  //     return this.product;
  //   })
  // }
}
